import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What services are covered under Pankaj Singh's terms?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The terms cover website design, development, consultation, SEO setup, plugin integration, domain and hosting support, and related services mentioned in the project proposal."
      }
    },
    {
      "@type": "Question",
      "name": "What is the payment policy for website design projects?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "An advance payment is required to initiate the project. The balance is payable before final delivery. All third-party costs must be borne by the client unless explicitly agreed."
      }
    },
    {
      "@type": "Question",
      "name": "Are there charges for revisions?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Limited revisions are included as per the agreement. Excessive or out-of-scope revisions will incur additional charges."
      }
    },
    {
      "@type": "Question",
      "name": "Does Pankaj Singh offer refunds?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Refunds are governed by the Refund Policy. Refunds are not available once work has begun, except under specific pre-approved cases. Please refer to the Refund Policy for full details."
      }
    },
    {
      "@type": "Question",
      "name": "Who owns the website after completion?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Upon final payment, the client owns the website, excluding any third-party tools or proprietary frameworks used under license."
      }
    },
    {
      "@type": "Question",
      "name": "Is maintenance included in the service?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Website maintenance is not included by default. It can be availed as a separate paid service on monthly, yearly, or per-task basis."
      }
    }
  ]
}


function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Terms and Conditions – Website Designers In Gurgaon</title>
<meta name="description" content="Review the Terms and Conditions of service for Pankaj Web Design – a freelance website designer in Gurgaon. Understand the terms of engagement, scope of work, and service limitations." />
<meta name="keywords" content="terms and conditions, pankaj web designer, freelance website developer, web design agreement, service terms gurgaon, website terms pankj.com" />
<meta property="og:title" content="Terms and Conditions – Website Designers in Gurgaon | Website Development Company" />
<meta property="og:description" content="These Terms and Conditions explain the rights and responsibilities between clients and Pankaj Web Design, covering scope, liability, revisions, and payments." />
<meta property="og:url" content="https://www.pankj.com/terms-and-conditions" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Terms and Conditions – Website Designers in Gurgaon" />
<meta name="twitter:description" content="Understand the service terms and conditions before hiring Pankaj Web Design for your website development needs in Gurgaon." />
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<link rel="canonical" href="https://www.pankj.com/terms-and-conditions" />
</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
{/*                <source src="assets/img/bg.mp4" type="video/mp4" />*/}
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />

 <h1 className="multiple_effects" id="text3d">Terms and Conditions</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.webp" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">

<section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Terms and Conditions</h2>
        </header>
        <div className="row">
          <div className="col-lg-12">
        <p><strong>Effective Date:</strong> July 12, 2025</p>
        <p><strong>Website:</strong> <a href="https://www.pankj.com">www.pankj.com</a></p>
        <p><strong>Email:</strong> <a href="mailto:info@pankj.com">info@pankj.com</a></p>

        <h3 className="text-xl font-semibold mt-6">1. Acceptance of Terms</h3>
        <p>
          By accessing or using services offered by Pankaj Singh, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our services.
        </p>

        <h3 className="text-xl font-semibold mt-6">2. Services Offered</h3>
        <p>
          We offer website design, development, hosting support, SEO setup, and related services as agreed in the proposal. The scope of services will be clearly discussed before the start of any project.
        </p>

        <h3 className="text-xl font-semibold mt-6">3. Project Timelines</h3>
        <p>
          Project timelines depend on client responsiveness and deliverables (content, images, approvals). Delays from the client side may extend the overall project duration.
        </p>

        <h3 className="text-xl font-semibold mt-6">4. Payment Terms</h3>
        <ul className="list-disc list-inside">
          <li>An advance is required to initiate the project.</li>
          <li>Remaining payment is due on completion before final handover or deployment.</li>
          <li>All third-party costs (domain, hosting, plugins) are to be borne by the client unless otherwise agreed.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6">5. Revisions & Approvals</h3>
        <p>
          We offer a limited number of design or content revisions as specified in the project agreement. Excessive or out-of-scope revisions will be chargeable.
        </p>

        <h3 className="text-xl font-semibold mt-6">6. Client Responsibilities</h3>
        <ul className="list-disc list-inside">
          <li>Providing timely feedback, approvals, and content.</li>
          <li>Ensuring legality of all submitted material (text, images, etc.).</li>
          <li>Maintaining backups if not on a maintenance plan.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6">7. Intellectual Property</h3>
        <p>
          Clients receive full ownership of the website upon final payment. However, proprietary code snippets, libraries, or frameworks remain the intellectual property of Pankaj Singh or respective third parties.
        </p>

        <h3 className="text-xl font-semibold mt-6">8. Limitation of Liability</h3>
        <p>
          We are not liable for any loss or damage caused by misuse of the website, delays in client responses, third-party plugin failures, or hosting/server issues.
        </p>

        <h3 className="text-xl font-semibold mt-6">9. Cancellation & Refunds</h3>
        <p>
          Refunds are governed by our <a href="/refund-policy" className="text-blue-600 underline">Refund Policy</a>. Please review that document for more details.
        </p>

        <h3 className="text-xl font-semibold mt-6">10. Maintenance and Support</h3>
        <p>
          Post-project support is available through maintenance plans or per-task billing. Free support is not included unless specified in the proposal.
        </p>

        <h3 className="text-xl font-semibold mt-6">11. Privacy Policy</h3>
        <p>
          Your data is protected in accordance with our <a href="/privacy-policy" className="text-blue-600 underline">Privacy Policy</a>.
        </p>

        <h3 className="text-xl font-semibold mt-6">12. Changes to Terms</h3>
        <p>
          Pankaj Singh reserves the right to update these Terms and Conditions at any time. It is the client’s responsibility to review them periodically.
        </p>

        <h3 className="text-xl font-semibold mt-6">13. Governing Law</h3>
        <p>
          These terms are governed by the laws of India. Any disputes will be resolved under the jurisdiction of the courts of Gurgaon, Haryana.
        </p>

        <h3 className="text-xl font-semibold mt-6">14. Contact Us</h3>
        <p>
          For any queries regarding these terms, please contact us at: <br />
          <strong>Email:</strong> <a href="mailto:info@pankj.com">info@pankj.com</a><br />
          <strong>Website:</strong> <a href="https://www.pankj.com">www.pankj.com</a>
        </p>

          </div>

        </div>
      </div>

    </section>    <Contact /> 
    </main>
    </>
  );
}
export default App1;
